/**!
 * Created by Leonardo Cheslacki on 28/06/2024.
 *
 * MIT License
 *
 * Copyright (c) 2024 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import LayerController from './LayerController';

import WithType from './../helpers/WithType';

let _this = {};

/**
 *
 */
class LayerPin extends LayerController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);
        this.props = props;
        this.main = main;

        this.state = {
            effect: true,
            occurrence: null
        }

        this.$children_temp = [];

        _this = this;
    };

    $functions = {

        /**
         *
         * @param event
         * @param data
         */
        handlePinShow: function (event, data) {
            _this.show(event, data);
        },

        handlePinClose: function () {
            _this.close();
        }
    };

    /**
     *
     * @param frame
     * @param occurrence {string | boolean}
     */
    navigate = (frame, occurrence = false) => {
        const
            {effect} = this.state,
            _this_current = this.get(),
            {occ_pin} = _this_current;

        if (frame !== 'empty') {
            occ_pin.gotoAndStop(frame);
            this.effectFadeIn(occ_pin, `occ_frame_${occurrence}`);
        } else {
            if (effect) {
                this.effectFadeOut(occ_pin, `occ_frame_${occurrence}`, () => {
                    occ_pin.gotoAndStop(frame);
                });
            } else {
                occ_pin.gotoAndStop(frame);
            }
        }

        this.setState({...this.state, effect: true});
    };

    close = () => {
        const {occurrence} = this.state;
        this.navigate('empty', occurrence);
    };

    /**
     *
     * @param event
     * @param occurrence
     */
    show = (event, {occurrence}) => {
        this.setState({...this.state, occurrence: occurrence}, () => {
            this.navigate(`frame${occurrence}`, occurrence);
        });
    };

    startPin = () => {
        const
            _this_current = this.get(),
            {occ_pin: {totalFrames, occ_modal: {btn_close}}} = this.get();

        /**
         *
         *  Add event in button for paginate in frame.
         */
        for (let i = 0; i < (totalFrames - 2); i++) {
            let
                occurrence = this.padWithLeadingZeros((i + 1), 2),
                btn_pin = this.verifyField(_this_current, `btn_pin_${occurrence}`),
                btn_pin_text = this.verifyField(_this_current, `btn_pin_text_${occurrence}`);

            if (btn_pin) {
                this.verifyField(btn_pin, 'occ_align.occ_effect') && (btn_pin.occ_align.occ_effect.visible = true);

                this.removeListener('mousedown', `click-pin-show-${occurrence}`, () => {
                    this.addListener(btn_pin, 'mousedown', `click-pin-show-${occurrence}`, this.$functions.handlePinShow, false, {
                        occurrence: occurrence
                    });
                });
            }

            if (btn_pin_text) {
                this.verifyField(btn_pin_text, 'occ_align.occ_effect') &&  (btn_pin_text.occ_align.occ_effect.visible = true);

                this.removeListener('mousedown', `click-pin-text-show-${occurrence}`, () => {
                    this.addListener(btn_pin_text, 'mousedown', `click-pin-text-show-${occurrence}`, this.$functions.handlePinShow, false, {
                        occurrence: occurrence
                    });
                });
            }
        }

        this._handlePinClose && btn_close.off('mousedown', this._handlePinClose);
        this._handlePinClose = btn_close.on('mousedown', this.$functions.handlePinClose);
    };

    /**
     *
     */
    initPin = () => {
        this.startPin();
    };
}

/**
 *
 * @type {{default_frame: Requireable<string>, name: Requireable<string>, current_name: Requireable<string>}}
 */
LayerPin.propTypes = {
    current_name: PropTypes.string,
    current_page: PropTypes.string
};

/**
 *
 * @type {{default_frame: string, name: string, current_name: null}}
 */
LayerPin.defaultProps = {
    current_name: null,
    current_page: null
};

/**
 *
 * @param ClassObject
 * @param className {className: 'className'}
 * @returns {function(*): function({}=): *} pass _this ClassMain (required) and props {} (optional)
 */
export default WithType(LayerPin, {className: 'LayerPin'});
